export * from './delete-extra-vereinbarung.service';
export * from './delete-extra-vereinbarung.service.module';